import { useMotionValueEvent, useScroll, useTransform } from 'framer-motion';
import { type RefObject, useRef, useState } from 'react';

import { usePDPContext } from '@/app/[locale]/product/_contexts/PDPProvider';

interface UseHeaderOpacity {
  container: RefObject<HTMLDivElement | null>;
  opacity: number;
}

const useHeaderOpacity = (): UseHeaderOpacity => {
  const { isSuccess: isProductSuccess } = usePDPContext();

  const [opacity, setOpacity] = useState<number>(0);
  const container = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    container,
    offset: ['start start', 'end end'],
  });

  const scrollY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  useMotionValueEvent(scrollY, 'change', (latest: number) => {
    if (!isProductSuccess) return;

    setOpacity(latest);
  });

  return { container, opacity };
};

export default useHeaderOpacity;
